export default function Storage() {
  return {
    getItem: (key) => {
      return new Promise((resolve, reject) => {
        fetch('/api/state',{
          method: 'GET',
          credentials: 'include'
        }).then(response => response.json())
        .then(json => json.state)
        .then(resolve);
      })
    },
    setItem: (key, item) => {
      return new Promise((resolve, reject) => {
        fetch('/api/state',{
          method: 'POST',
          body:JSON.stringify( {state: item}),
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          }      
        }).then(response => response)
        .then(resolve);
      })
    },
    removeItem: (key) => {
      return new Promise((resolve, reject) => {
        fetch('/api/state?reset=true',{
          method: 'DELETE',
          credentials: 'include'
        }).then(response => response)
        .then(resolve);
      })
    },
  }
}


// WEBPACK FOOTER //
// ./src/utils/Storage.js